/**
 * `/coffee` — every coffee machine, one card each, behind `coffee.use`. Each
 * card reads its own status, so a slow or failing cloud holds up only the
 * cards of its own machines.
 */
import { useTranslation } from 'react-i18next';
import CoffeeIcon from '@mui/icons-material/Coffee';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { AsyncContent } from '../../components/AsyncContent';
import { EmptyState } from '../../components/EmptyState';
import { PageHeader } from '../../components/PageHeader';
import { useAsync } from '../../hooks/useAsync';
import { listMachines } from './api';
import { MachineCard } from './MachineCard';

export default function MachinesPage() {
  const { t } = useTranslation('coffee');
  const machines = useAsync(listMachines, []);

  return (
    <>
      <PageHeader title={t('machines.title')} description={t('machines.description')} />
      <AsyncContent state={machines}>
        {({ machines: list }) =>
          list.length === 0 ? (
            <Paper variant="outlined">
              <EmptyState
                icon={<CoffeeIcon fontSize="inherit" />}
                title={t('machines.emptyTitle')}
                description={t('machines.emptyDescription')}
              />
            </Paper>
          ) : (
            <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', xl: '1fr 1fr 1fr' } }}>
              {list.map((machine) => (
                <MachineCard key={machine.id} machine={machine} />
              ))}
            </Box>
          )
        }
      </AsyncContent>
    </>
  );
}
